import React, { useState } from 'react';
import { actionableConditions } from '../../../../services/actionableCondition';
import { usePermissions } from '../../../../context/PermissionContext';
 
const useActionableCondition= () => {

  const [loading, setLoading] = useState(false);
  const [actionableConditionsState, setActionableConditionsState] = useState([]);
  const [actionableConditionsSequence, setActionableConditionsSequence] = useState([]);
  const [actionableConditionsLoaded, setActionableConditionsLoaded] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");
  const [accessDenied, setAccessDenied] = useState(false);
  const permission = usePermissions();
  const tabOptions = [
    { label: "All", value: "all" },
    // { label : "High Returns" , value : "high_return_rate" },
    { label : "High Refunds" , value : "high_rejection_rate" },
    { label : "High Cancellations" , value : "high_cancellation_rate" },
    { label : "High Replacements % " , value : "high_replacement_rate" },
    { label : "High Fees (18%–22%)"  , value : "high_amazon_fees" },
  ];
  
  const canShowTable =
    (permission?.data?.actionable_conditions?.view_format.category_wise.display &&
      permission?.data?.actionable_conditions?.view_format.category_wise.allowed) ||
    (permission?.data?.actionable_conditions?.view_format.product_wise.display &&
      permission?.data?.actionable_conditions?.view_format.product_wise.allowed);

  const combinedPermission = {
    display:
      permission?.data?.actionable_conditions?.view_format.category_wise.display ||
      permission?.data?.actionable_conditions?.view_format.product_wise.display,
    allowed:
      permission?.data?.actionable_conditions?.view_format.category_wise.allowed ||
      permission?.data?.actionable_conditions?.view_format.product_wise.allowed,
  };
  
  const filteredTabs = React.useMemo(() => {
    const insightPermissions = permission?.data?.actionable_conditions?.insights || {};

    return tabOptions
      .filter((tab) => {
        const perm = insightPermissions[tab.value];
        // Only exclude when both display = false AND allowed = false
        return !(perm?.display === false && perm?.allowed === false);
      })
      .map((tab) => {
        const perm = insightPermissions[tab.value];
        return {
          ...tab,
          permission: perm, // attach permission to drive blur/visible logic
        };
      });
  }, [tabOptions, permission]);

  const selectedTabPermission =
    permission?.data?.actionable_conditions?.insights[selectedTab] || {};

  const tablePermission =
    permission?.data?.actionable_conditions?.table_section.table_view || {};

  const combinedTablePermission = {
    display: selectedTabPermission.display && tablePermission.display,
    allowed: selectedTabPermission.allowed && tablePermission.allowed,
  };



  const getActionableConditions = async ({ formattedEnd , formattedStart , selectedIds = [] , selectedTab }) =>{
    setLoading(true);
    setActionableConditionsLoaded(false)
    try {
      let response = await actionableConditions({ formattedEnd , formattedStart , selectedIds, selectedTab });
      if (response && response.success && response.data) {
        setActionableConditionsState(response.data);
        setActionableConditionsSequence(response?.sequence);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
      if (error.status === 403){
        setAccessDenied(true)
      }
    } finally {
      setLoading(false);
      setActionableConditionsLoaded(true); // ✅ Mark loaded
    }
  }

  return {
    actionableConditionsLoaded , loading, actionableConditionsSequence, actionableConditionsState, getActionableConditions, selectedTab, setSelectedTab , tabOptions, filteredTabs, selectedTabPermission, tablePermission, combinedTablePermission, canShowTable, combinedPermission,accessDenied
  };
};

export default useActionableCondition;
